// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__38zZ8","label":"Labeled_label__2k8ao","divider":"Labeled_divider__14QMR"};